@if (isAuthenticated) {
  <span class="myShop-toggle-button">
    <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center form-switch p-0">
      <input class="form-check-input c-pointer m-1" type="checkbox" id="myShopSwitchCheck" [checked]="myShopActive"
        (click)="shopContextToggle()">
      <label class="form-check-label c-pointer fs-5 fw-bold m-1 text-nowrap" for="myShopSwitchCheck">
        <span i18n="@@MyShopToggleButton">My Shop</span>
        <i class="bi bi-star m-1 d-none d-lg-block"></i>
      </label>
    </div>
  </span>
}
